<template>
  <div>
    <ul class="articles_tree">
      <li class="articles_tree__new">
        <router-link :to="{ name: 'articles-edit', params: {space_id: space_id, article_id: 0}, query: {parent_id: 0}}">
          <span>+ Add article</span>
        </router-link>
      </li>
      <tree-item v-for="item in items" :space_id="space_id" :data="item"></tree-item>
    </ul>
  </div>
</template>

<script>
  import item from '@/components/spaces/item'

  export default {
    name: 'TreeView',
    props: ['items', 'space_id'],
    components: {
      'tree-item': item
    }
  }
</script>
